export var ServiceName;
(function (ServiceName) {
    ServiceName["DocumentManagement"] = "documentManagement";
    ServiceName["ProjectManagement"] = "projectManagement";
    ServiceName["ProjectAdministration"] = "projectAdministration";
    ServiceName["CostManagement"] = "costManagement";
    ServiceName["Quantification"] = "quantification";
    ServiceName["DesignCollaboration"] = "designCollaboration";
    ServiceName["FieldManagement"] = "fieldManagement";
    ServiceName["Assets"] = "assets";
    ServiceName["Insight"] = "insight";
    ServiceName["ModelCoordination"] = "modelCoordination";
    ServiceName["Rfis"] = "rfis";
    ServiceName["Submittals"] = "submittals";
    ServiceName["Meetings"] = "meetings";
    ServiceName["Schedule"] = "schedule";
    ServiceName["Field"] = "field";
    ServiceName["Glue"] = "glue";
    ServiceName["Plan"] = "plan";
    ServiceName["Iq"] = "iq";
    ServiceName["Api"] = "api";
})(ServiceName || (ServiceName = {}));
export var ServiceStatus;
(function (ServiceStatus) {
    ServiceStatus["Active"] = "active";
    ServiceStatus["Activating"] = "activating";
    ServiceStatus["Available"] = "available";
    ServiceStatus["Inactive"] = "inactive";
    ServiceStatus["Deactivating"] = "deactivating";
    ServiceStatus["ActivationFailed"] = "activationFailed";
    ServiceStatus["DeactivationFailed"] = "deactivationFailed";
})(ServiceStatus || (ServiceStatus = {}));
export var TemplateCreateType;
(function (TemplateCreateType) {
    TemplateCreateType["Blank"] = "template-blank";
    TemplateCreateType["FromProject"] = "template-from-project";
})(TemplateCreateType || (TemplateCreateType = {}));
export var SubmitError;
(function (SubmitError) {
    SubmitError["DuplicateName"] = "duplicate-name";
    SubmitError["InvalidName"] = "invalid-name";
    SubmitError["NameTooLong"] = "name-too-long";
    SubmitError["Other"] = "other";
})(SubmitError || (SubmitError = {}));
export var BannerError;
(function (BannerError) {
    BannerError["Name"] = "name";
    BannerError["Other"] = "other";
})(BannerError || (BannerError = {}));
